import React from 'react';
import { IDataType, SisDataGrid, SisDataGridColumns } from '../../components/table';
import { useTranslation } from '../../contexts/translation';

type Props = {
  historyItems: any;
};

export const CustomerProjectsHistory = ({ historyItems }: Props) => {
  const transFormName = 'CustomersProjects.History';
  const { translate } = useTranslation();

  const onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift({
      location: 'before',
      html: translate!('History', transFormName),
    });
  };

  const columns: SisDataGridColumns = [
    {
      dataField: 'description',
      caption: 'Description',
      width: '50%',
    },
    {
      dataField: 'created',
      caption: 'Created',
      dataType: IDataType.dateTime,
      format: 'dd.MM.yy HH:mm',
      width: '25%',
    },
    {
      dataField: 'createdByName',
      caption: 'Created by',
      width: '25%',
    },
  ];

  return (
    <SisDataGrid
      onToolbarPreparing={onToolbarPreparing}
      allowColumnReordering={false}
      allowColumnResizing={false}
      columnChooser={false}
      filterRow={false}
      data={historyItems}
      keyExpr={'id'}
      transFormName={transFormName}
      columns={columns}
    />
  );
};
